import React from 'react';
import { withRouter } from "react-router-dom"
import { withStyles } from '@material-ui/core/styles';
import LiveVideo from './LivevVideo'
import { IconButton, Avatar, Button, Typography } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import TextsmsIcon from '@material-ui/icons/Textsms';
import ShareIcon from '@material-ui/icons/Share';

import DefaultAvatarImg from '../../images/change/default_avatar.png';
import AppData from '../../model/AppData';
import MBackIcon from '../view/MBackIcon';


const styles = (theme) => ({
    root: {
        backgroundSize: 'cover',
        width: '100vw',
        height: '100vh',
        display: "flex",
        backgroundColor: theme.palette.background.default,
        flexDirection: "row",
        alignItems: 'center',
        justifyContent: 'center',
    },
    avatar: {
        width: 52,
        height: 52,
        color: '#fff',
        backgroundSize: 'cover',
        backgroundImage: `url(${DefaultAvatarImg})`,
    },
    secondaryText: {
        color: '#fff',
        height: 30,
        marginTop: -5,
    },
});

class LivePlayerPage extends React.Component {

    constructor(props) {
        super(props);
        // src: 'rtmp://live.hkstv.hk.lxdns.com/live/hks',
        this.state = {
            avatar: AppData.me.Pic,
            title: '@324"666',
            content: '公厕轮流艹美女',
            share: 5,
            chat: 50,
            love: 20,
            liveUrl: 'rtmp://58.200.131.2:1935/livetv/hunantv',
        };
    }

    render() {
        const { classes } = this.props;
        const { liveUrl, title, content, share, chat, love } = this.state;
        const videoJsOptions = {
            autoplay: true,  //自动播放
            language: 'zh-CN',
            controls: false,  //控制条
            preload: 'auto',  //自动加载
            errorDisplay: true,  //错误展示
            // width: document.body.clientWidth,  //宽
            // width: window.screen.width,
            height: window.screen.height,
            userActions: { hotkeys: true },
            sources: [{ src: liveUrl }]
        };
        return (
            <React.Fragment>
                <div className={classes.root}>
                    <LiveVideo {...videoJsOptions} />
                    <div style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'transparent' }}>
                        <MBackIcon />
                    </div>
                    <div style={{ position: 'absolute', right: 20, bottom: 80 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: 50 }}>
                            <Button>
                                <div style={{ flexDirection: 'row' }}>
                                    <Avatar style={{ width: 40, height: 40 }} className={classes.avatar} src={this.state.avatar} />
                                    <Typography className={classes.secondaryText}></Typography>
                                </div>
                            </Button>
                            <Button>
                                <div style={{ flexDirection: 'row' }}>
                                    <FavoriteIcon style={{ width: 40, height: 40 }} />
                                    <Typography className={classes.secondaryText}>{love}</Typography>
                                </div>
                            </Button>
                            <Button>
                                <div style={{ flexDirection: 'row' }}>
                                    <TextsmsIcon style={{ width: 40, height: 40 }} />
                                    <Typography className={classes.secondaryText}>{chat}</Typography>
                                </div>
                            </Button>
                            <Button>
                                <div style={{ flexDirection: 'row' }}>
                                    <ShareIcon style={{ width: 40, height: 40 }} />
                                    <Typography className={classes.secondaryText}>{share}</Typography>
                                </div>
                            </Button>
                        </div>
                    </div>
                    <div style={{ position: 'absolute', left: 20, bottom: 40 }}>
                        <div style={{ flexDirection: 'row' }}>
                            <Typography className={classes.secondaryText}>{title}</Typography>
                            <Typography className={classes.secondaryText}>{content}</Typography>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default withRouter(withStyles(styles)(LivePlayerPage));